import { deleteSavedItem as deleteSavedItemUsingSdk } from "../../../../services/savedItems";
import { getProductVariantAndColourWayIds } from "../selectors";
import { DELETE_ITEM, DELETED_ITEM_SUCCESS } from "../constants";
import { CLEAR_ERRORS, ERROR } from "../../common/constants";
import { LoggedError, ServiceError } from "../../../../services/errors";

export const deleteSavedItem =
  ({ id }) =>
  async (dispatch, getState) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({
      type: DELETE_ITEM,
      payload: { id, ...getProductVariantAndColourWayIds(getState(), id) }
    });
    try {
      await deleteSavedItemUsingSdk(id);
    } catch (e) {
      if (e instanceof ServiceError) {
        return dispatch({
          type: ERROR,
          payload: {
            id,
            failedActionType: DELETE_ITEM,
            canBeRetried: true
          }
        });
      }
      throw new LoggedError(e, LoggedError.error);
    }
    dispatch({ type: DELETED_ITEM_SUCCESS, payload: { id } });
  };
